export default __webpack_public_path__ + "5223c57570997152dbe2b0f1abb7d2cd.svg";